export const MOCK_AUTH_USER = {
  id: 'dev-mock-user',
  name: 'Local Dev (mock)',
  email: 'dev@example.local',
  picture: null as string | null,
  // Dev-mock signs in as an admin so the admin dashboard, users pages, and analytics
  // charts (served from mockAdmin.ts) are all reachable without a backend.
  isAdmin: true,
}
